module.exports = __webpack_public_path__ + "img/hr-splitter-west.48fafc6b.png";